<div style="text-align: left;">
  <a routerLink="../" >返回</a>
</div>
<hr>


<img class="img-fluid" src="assets/images/ICT2018.jpg" alt="">
